import { render, staticRenderFns } from "./listReview.vue?vue&type=template&id=3a6bca82&scoped=true&"
import script from "./listReview.vue?vue&type=script&lang=js&"
export * from "./listReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6bca82",
  null
  
)

export default component.exports